// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_mp-0";
export var discountCodeInput = "_mp-1";